import { signout } from '@features/common';
import { chatOpened } from '../chat/chat.model';
import { $error, clearError, errorOccured } from './error.model';

$error
  .on(errorOccured, (state, { error }) => {
    return JSON.parse(error.message ?? '{}');
  })
  .reset([chatOpened, signout, clearError]);
